<template>
    <div id="content" class="w">
        <!-- 当前位置 -->
        <div class="s_tl">
            <div class="left wov">
                当前位置：<a href="/">首页</a>
                <code class="lr3">&gt;</code>
                <a href="javascript:;">学堂中心</a>
                <code class="lr3">&gt;</code>
                <router-link :to="{path:'/article', query:{cate_id:articleInfo.cate_id}}" target="_blank">
                    {{articleInfo.cate_cn}}
                </router-link>
                <code class="lr3">&gt;</code>
                {{articleInfo.title}}
            </div>
        </div>
        <div class="scat over" style="padding:10px;">
            <div style="text-align:center">
                <h1 style="font-size:24px;font-weight:bold;line-height:45px;color:#2c3e50">{{articleInfo.title}}</h1>
                <div style="font-size:16px; line-height:45px;border-bottom: 1px solid #f5f5f5;">
                    <span style="margin-right:50px;">责任编辑：{{articleInfo.editor}}</span>
                    <span style="margin-right:50px;">所属行业：{{articleInfo.cate_cn}}</span>
                    <span style="margin-right:50px;"><i class="iconfont icon-chakan"></i> {{articleInfo.hit}}</span>
                    <span>{{$fnc.getTimeFormat(articleInfo.created_time)}}</span>
                </div>
            </div>
            <div class="detail_content" v-html="articleInfo.content">
                {{articleInfo.content}}
                <!-- <div class="zerenbianji">责任编辑：{{articleInfo.editor}}</div> -->
                
            </div>
            <div class="detail_content">
                <p style="line-height:40px; font-size:16px;">
                    上一篇：
                    <span class="artHover" v-if="articleInfo.front == '没有了'">没有了</span>
                    <span class="artHover">
                        <router-link :to="{path:'/article_detail', query:{id:articleInfo.front[0].id}}" target="_blank">
                            {{articleInfo.front[0].title}}
                        </router-link>
                    </span>

                </p>
                <p style="line-height:40px; font-size:16px;">
                    下一篇：
                    <span class="artHover" v-if="articleInfo.after == '没有了'">没有了</span>
                    <span class="artHover">
                        <router-link :to="{path:'/article_detail', query:{id:articleInfo.after[0].id}}" target="_blank">
                            {{articleInfo.after[0].title}}
                        </router-link>
                    </span>
                </p>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            articleInfo:[]
        }
    },
    created(){
        this.getNewsInfo(this.$route.query.id);
    },
    methods:{
        //获取数据
        getNewsInfo(id) {
            var params = {};
            params.id = id || "";
            // params.uid = JSON.parse(window.localStorage.getItem("user")).id || "";
            this.$api.getArticle.getNewsInfo(params).then(res => {
                if (res.code == 200) {
                    this.articleInfo = res.result;
                    console.log(this.articleInfo.after)
                    if(this.articleInfo.after.length == 0){
                        this.articleInfo.after = '没有了';
                        console.log(this.articleInfo.after)
                    }
                    if(this.articleInfo.front.length == 0){
                        this.articleInfo.front = '没有了';
                    }
                }
            });
        },
    }
}
</script>

<style scoped>
.artHover:hover{
    color:#f00180;
}
</style>


// WEBPACK FOOTER //
// src/components/article/article_detail.vue